var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page",class:_vm.view.class},[_c('NavBar'),_vm._l((_vm.view.articles),function(article,index){return _c(_vm.getComponentType(article.type),{key:'article-'+index,tag:"component",attrs:{"article":article}})})],2)}
var staticRenderFns = []

export { render, staticRenderFns }